import { render, staticRenderFns } from "./addDialog.vue?vue&type=template&id=2dbc896b&scoped=true&"
import script from "./addDialog.vue?vue&type=script&lang=js&"
export * from "./addDialog.vue?vue&type=script&lang=js&"
import style0 from "./addDialog.vue?vue&type=style&index=0&id=2dbc896b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbc896b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/nisems/front/nisbos-front-admin/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dbc896b')) {
      api.createRecord('2dbc896b', component.options)
    } else {
      api.reload('2dbc896b', component.options)
    }
    module.hot.accept("./addDialog.vue?vue&type=template&id=2dbc896b&scoped=true&", function () {
      api.rerender('2dbc896b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ls-form/components/saas/dialog/addDialog.vue"
export default component.exports